import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Navbar from "./components/site/Navbar";
import Hero from "./components/site/Hero";
import IndustryBand from "./components/site/IndustryBand";
import Services from "./components/site/Services";
import FeaturedAI from "./components/site/FeaturedAI";
import DemoVideo from "./components/site/DemoVideo";
import WhyCoreScale from "./components/site/WhyCoreScale";
import Comparison from "./components/site/Comparison";
import Process from "./components/site/Process";
import CaseStudies from "./components/site/CaseStudies";
import BusinessNeeds from "./components/site/BusinessNeeds";
import FAQ from "./components/site/FAQ";
import FinalCTA from "./components/site/FinalCTA";
import ContactForm from "./components/site/ContactForm";
import Footer from "./components/site/Footer";
import MobileStickyCTA from "./components/site/MobileStickyCTA";
import useScrollReveal from "./hooks/useScrollReveal";

const Landing = () => {
  useScrollReveal();
  return (
    <div
      className="min-h-screen bg-[#050505] text-white selection:bg-[#39FF14]/30 overflow-x-hidden"
      data-testid="landing-page"
    >
      <a href="#main-content" className="skip-link" data-testid="skip-to-content">
        Skip to content
      </a>
      <Navbar />
      <main id="main-content">
        <Hero />
        <IndustryBand />
        <Services />
        <FeaturedAI />
        <DemoVideo />
        <WhyCoreScale />
        <Comparison />
        <Process />
        <CaseStudies />
        <BusinessNeeds />
        <FAQ />
        <FinalCTA />
        <ContactForm />
      </main>
      <Footer />
      <MobileStickyCTA />
    </div>
  );
};

function App() {

  useEffect(() => {
    const script = document.createElement("script");

    script.src = "https://beta.leadconnectorhq.com/loader.js";

    script.setAttribute(
      "data-resources-url",
      "https://beta.leadconnectorhq.com/chat-widget/loader.js"
    );

    script.setAttribute(
      "data-widget-id",
      "6a15dd701ce15bb9e92410df"
    );

    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}
export default App;
